import { toast } from 'react-toastify';

// Geocoding and distance calculation helpers

const GEOCODE_API_URL = 'https://geocoding-api.open-meteo.com/v1/search';

// Cache for geocoding results
const geocodeCache = new Map();

// Geocode a location (zip code or city, state)
export const geocodeLocation = async (query) => {
  if (!query || query.trim() === '') return null;
  const locationArray = query.split(',');
  const [city, state] = locationArray;
  const isZip = locationArray.length === 1;


  const cacheKey = query.trim();
  if (geocodeCache.has(cacheKey)) {
    return geocodeCache.get(cacheKey);
  }

  try {
    const params = isZip ? `name=${query}&count=1&format=json&language=en` : `name=${encodeURIComponent(city)}&state=${encodeURIComponent(state)}&count=1&format=json&language=en`;

    const response = await fetch(`${GEOCODE_API_URL}?${params}`);
    const data = await response.json();

    if (data.results && data.results.length > 0) {
      const result = {
        lat: data.results[0].latitude,
        lng: data.results[0].longitude,
        name: data.results[0].name
      };
      geocodeCache.set(cacheKey, result);
      return result;
    }
    console.error('Geocoding failed for', query);
    toast.error(`Geocoding failed for ${query}`);
  } catch (error) {
    console.error('Geocoding error:', error);
  }

  // Cache negative result for a longer time to avoid repeated failed requests
  geocodeCache.set(cacheKey, null);
  return null;
};

// Haversine formula to calculate distance between two coordinates in kilometers
export const calculateHaversineDistance = (lat1, lng1, lat2, lng2) => {
  const R = 6371; // Earth's radius in kilometers

  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;

  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLng/2) * Math.sin(dLng/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

  return R * c;
};

// Calculate distance between two locations
export const getDistance = async (fromQuery, toQuery) => {
  if (!fromQuery || !toQuery) return Infinity;

  const [fromCoords, toCoords] = await Promise.all([
    geocodeLocation(fromQuery),
    geocodeLocation(toQuery)
  ]);

  if (!fromCoords || !toCoords) return Infinity;

  return calculateHaversineDistance(fromCoords.lat, fromCoords.lng, toCoords.lat, toCoords.lng);
};
